var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"img-fluid",staticStyle:{"width":"75px"},attrs:{"src":require("../../../../assets/images/logo/efatura.png")},on:{"click":function($event){return _vm.EBelge()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }